export const eventsStyles = () => ({
    root: {
        margin: '0',
        padding: '0',
        backgroundColor: '#0B1432',
        boxSizing: 'border-box',
        minHeight: '100vh',
        width: '100%',
        color: 'white',
    },
    itemContainer: {
        marginTop: '0%',
        display: 'flex',
        // justifyContent: 'center',
        alignItems: 'center',
    }
  });
